
var AuthorizedBodyInformation = (function () {
    const URL = './ASPWebDataServise.asmx/';

    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var _setInformation = response => {
        let a = JSON.parse(response.d);

        if ($.isEmptyObject(a) || a.HasError) {
            $('.content').append('<div class="text-center m-5">Информация не найдена </div>');
            return false;
            //To DO:
        }

        let description = JSON.parse(a.Description);
        if (!description || $.isEmptyObject(description)) {
            $('.content').append('<div class="text-center m-5">Данных об уполномоченном органе не найдено</div>');
            return false;
            //To DO:
        }

        const MENU_OBJECT = {
            "AuthorizedBody": "Уполномоченный орган",
            "FuulCaption": "Полное наименование органа",
            "Address": "Адрес",
            "Phone": "Телефон",
            "Email": "Электронная почта",
            "WebSite": "Сайт",
            "Route": "Как проехать",
            "Fio": "ФИО руководителя",
            "Schedule": "График работы учреждения",
            "Founder": "Учредитель",
            "ProcedureSocialServices": "Порядок обращения за предоставлением социальных услуг",
            "ListSocialServices": "Перечень социальных услуг и мероприятий соц.сопровождения"
        };

        $('.content').html('');
        for (let item in description) {
            let txt = `<dt class="col-sm-5">${MENU_OBJECT[item]}</dt>
                            <dd class="col-sm-7">${description[item]}</dd>`;
            $('.content').append(txt);
        }

        let files = a.Files;
        if (!files || files.length == 0) {
            $('.files').html('');
            return false;
            //To DO:
        }
        $('.files-content').html('');
        files.forEach((value, index) => {
            let txt = `<div class="row justify-content-between p-1"><div class="col">${index+1}. Файл ${value.File}</div>
                            <div class="col"><a href="./DownloadFile.ashx?file=${value.File}" class="btn btn-outline-primary">Скачать</a></div></div>`;
            $('.files-content').append(txt);
        });
    };


    // точка входа 
    var init = () => {
        let promise = _fetchAsync(URL, 'GetAuthorizedBodyInformation', {}).then(response => _setInformation(response), err => console.error(`ошибка при получении данных: ${err}`));
    };

    return {
        // public методы
        init: init,
    };
}());

(function main() {
    $("body").fadeIn(2000);
    AuthorizedBodyInformation.init();
}());